var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lead-view-right" },
    [
      _c("div", { staticClass: "lead-edit" }, [
        _c("div", { staticClass: "lead-edit-menu" }, [
          _c("div", { staticClass: "lead-edit-menu-list" }, [
            _c(
              "ul",
              { staticClass: "edit-menu-list" },
              _vm._l(_vm.tabs, function (tab) {
                return _c(
                  "li",
                  {
                    staticClass: "edit-menu-list--item",
                    class: { "edit-menu-list-active": tab.isActive },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab(tab.code)
                      },
                    },
                  },
                  [_c("a", [_vm._v(_vm._s(tab.name))])]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gen-form-container" },
          [
            _vm.activeTab === "comment" ? _c("comment-tab") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "deposits" ? _c("transactions-tab") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "profile" ? _c("profile-tab") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "documents" ? _c("document-tab") : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "sp_trades" ? _c("sp-trades-tab") : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("time-line-tab"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }